import routeCodes from '../common/constants/route-codes';
import moment from 'moment';
import { ReactComponent as DeliveryIcon } from 'assets/images/delivery_icon.svg';
import {
  orderStatuses,
  OrderTypes,
  reservationStatuses,
} from 'common/constants/orders';
import { ReactComponent as ReservationIcon } from 'assets/images/reservation_icon.svg';
import AsportoIcon from 'assets/images/Asporto Icon@4x.svg';
import React from 'react';

export const getEditableIdByUrl = (location, params) => {
  const { pathname } = location;
  const { id } = params;
  if (!id) {
    return null;
  }
  let mainPath = '';
  const categories = {
    restaurant: 'restaurant',
    firm: 'firm',
    profile: 'profile/account',
    profileEdit: 'profile/account',
  };

  if (pathname.includes(categories.restaurant)) {
    mainPath = categories.restaurant + 's';
  } else if (pathname.includes(categories.firm)) {
    mainPath = categories.firm + 's';
  } else if (
    pathname.includes(categories.profile) ||
    pathname.includes(categories.profileEdit)
  ) {
    mainPath = 'profile';
  }

  if (pathname.includes(routeCodes.menuDishes)) {
    mainPath = 'dishes';
  }
  if (pathname.includes(routeCodes.specialMenu)) {
    mainPath = 'special-menu';
  }
  if (pathname.includes(routeCodes.menuOptions)) {
    mainPath = 'dish-options';
  }
  if (pathname.includes(routeCodes.menuCategories)) {
    mainPath = 'dish-categories';
  }

  return { id: `${mainPath}_${id}` };
};

export const getModalTitleFromCategory = (id) => {
  switch (id) {
    case 'profile':
      return 'Elimina gestore';
    case 'firms':
      return 'Elimina società';
    case 'restaurants':
      return 'Elimina attività';
    case 'dishes':
      return 'Elimina Piatto';
    case 'special-menu':
      return 'Elimina Menù speciali';
    case 'dish-options':
      return 'Elimina opzioni';
    case 'dish-categories':
      return 'Elimina Categoria';
    default:
      return '';
  }
};

export const getModalBodyTextFromCategory = (id) => {
  switch (id) {
    case 'profile':
      return 'Sei sicuro che vuoi cancellare';
    case 'firms':
      return 'Vuoi davvero eliminare la società';
    case 'restaurants':
      return 'Vuoi davvero eliminare l\'attività';
    case 'dishes':
      return 'Vuoi cancellare';
    case 'dish-options':
      return 'Sei sicuro di voler eliminare la opzioni';
    case 'dish-categories':
      return 'Vuoi cancellare';
    case 'special-menu':
      return 'Vuoi cancellare';

    default:
      return '';
  }
};

export const loadScript = (url, callback) => {
  let script = document.createElement('script'); // create script tag
  script.type = 'text/javascript';

  // when script state is ready and loaded or complete we will call callback
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url; // load by url
  document.getElementsByTagName('head')[0].appendChild(script); // append to head
};

export const getImageUrl = (path) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  // return `https://api-dev.ristorabergamo.it${path}`;
  return `${apiUrl.replace('/api/v1', '')}${path}`;
};

export const getCategoryAndTitle = (string) => string?.split('_');

export const getErrorByKey = (errors, key) => {
  if (!errors || !key) return null;
  
  try {
    // Handle nested keys with dots (e.g., "services_rooms.total_seats")
    if (key.includes('.')) {
      const keys = key.split('.');
      let error = errors;
      
      for (const k of keys) {
        if (error && typeof error === 'object') {
          error = error[k];
        } else {
          error = null;
          break;
        }
      }
      
      if (!error) return null;
      
      // If error is already a string, return it
      if (typeof error === 'string') {
        return error;
      }
      
      // If error is an array, join it
      if (Array.isArray(error)) {
        return error.join(' ');
      }
      
      // If error is an object, try to get the first value
      if (typeof error === 'object') {
        const firstKey = Object.keys(error)[0];
        if (firstKey) {
          const firstError = error[firstKey];
          if (Array.isArray(firstError)) {
            return firstError.join(' ');
          }
          return firstError;
        }
      }
      
      // If none of the above, convert to string
      return String(error);
    }
    
    // Handle regular keys
    const error = errors[key];
    if (!error) return null;
    
    // If error is already a string, return it
    if (typeof error === 'string') {
      return error;
    }
    
    // If error is an array, join it
    if (Array.isArray(error)) {
      return error.join(' ');
    }
    
    // If error is an object, try to get the first value
    if (typeof error === 'object') {
      const firstKey = Object.keys(error)[0];
      if (firstKey) {
        const firstError = error[firstKey];
        if (Array.isArray(firstError)) {
          return firstError.join(' ');
        }
        return firstError;
      }
    }
    
    // If none of the above, convert to string
    return String(error);
  } catch (error) {
    console.warn('Error in getErrorByKey:', error);
    return null;
  }
};

export const haseFileError = (file) => {
  if (!file) {
    return {};
  }
  const imageMaximalSize = 150;
  const size = (file?.size / (1024 * 1024)).toFixed(2);
  const isAcceptedFileTypes =
    file?.type?.includes('jpeg') ||
    file?.type?.includes('jpg') ||
    file?.type?.includes('png');

  return {
    size: imageMaximalSize < size,
    mimeType: !isAcceptedFileTypes,
  };
};

export const getBergamoCoords = () => ({
  lat: 45.695,
  lng: 9.67,
});

export const getCreateButtonTextInProfile = (id, isRestaurant, items) => {
  const hasItems = items.length > 0;
  const addText = 'Aggiungi';
  if (id === 'profile') {
    return hasItems ? '+ Aggiungi gestore' : '+ Crea gestore';
  }
  if (id === 'firms') {
    return hasItems ? '+ Aggiungi società' : '+ Crea società';
  }
  if (isRestaurant) {
    return hasItems ? '+ Aggiungi insegna' : '+ Crea insegna';
  }
  return addText;
};

export const getCreateButtonTextInMenu = (id, items) => {
  const hasItems = items.length > 0;
  const addText = '+ Crea piatto/prodotto';
  if (id === 'dishes') {
    return !hasItems ? '+ Aggiungi piatto/prodotto' : '+ Crea piatto/prodotto';
  }

  if (id === 'dish-categories') {
    return !hasItems ? '+ Aggiungi categoria' : '+ Crea categoria';
  }

  if (id === 'dish-options') {
    return !hasItems ? '+ Aggiungi opzione' : '+ Crea opzione';
  }
  if (id === 'special-menu') {
    return !hasItems ? '+ Aggiungi menù speciale' : '+ Crea menù speciale';
  }

  return addText;
};

export const getNextStep = (steps = {}, step) => {
  const keys = Object.keys(steps);
  const index = keys.findIndex((i) => step === i);
  const nextKey = keys[index + 1];
  return steps[nextKey];
};

export const getPreviousStep = (steps = {}, step) => {
  const keys = Object.keys(steps);
  const index = keys.findIndex((i) => step === i);
  const nextKey = keys[index - 1];
  return steps[nextKey];
};

export const objectToFormData = (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    data[key] !== null && formData.append(key, data[key]);
  });

  return formData;
};

export const getDayHourPerHalf = (startPerHalfHour = 6, valueKey = 'value') => {
  const items = [];
  new Array(24).fill().forEach((acc, index) => {
    if (index >= startPerHalfHour) {
      items.push({
        title: moment({ hour: index }).format('HH:mm'),
        [valueKey]: moment({ hour: index }).format('HH:mm'),
      });
      items.push({
        title: moment({ hour: index, minute: 30 }).format('HH:mm'),
        [valueKey]: moment({ hour: index, minute: 30 }).format('HH:mm'),
      });
    }
  });
  return items;
};

export const isEmptyObject = (object) => {
  return Object.keys(object).length === 0;
};

export const getFilteredList = (mainList = [], selectedList = []) => {
  const filtered = [];
  mainList.forEach((mainItem) => {
    if (!selectedList.find((i) => parseInt(i.id) === parseInt(mainItem.id))) {
      filtered.push(mainItem);
    }
  });

  return filtered;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const getWeekDaysForChip = () => {
  return [
    { id: 'monday', title: 'Lunedì' },
    { id: 'tuesday', title: 'Martedì' },
    { id: 'wednesday', title: 'Mercoledì' },
    { id: 'thursday', title: 'Giovedì' },
    { id: 'friday', title: 'Venerdì' },
    { id: 'saturday', title: 'Sabato' },
    { id: 'sunday', title: 'Domenica' },
  ];
};

export const getSelectedDays = (data) => {
  const values = [];
  if (data.friday) {
    values.push('friday');
  }
  if (data.monday) {
    values.push('monday');
  }
  if (data.sunday) {
    values.push('sunday');
  }
  if (data.tuesday) {
    values.push('tuesday');
  }
  if (data.saturday) {
    values.push('saturday');
  }
  if (data.thursday) {
    values.push('thursday');
  }
  if (data.wednesday) {
    values.push('wednesday');
  }

  return values;
};

export const getErrorTexts = (errors = {}) => {
  const result = [];

  Object.keys(errors).forEach((key) => {
    const error = errors[key];
    result.push(error);
  });

  return result.join('\n');
};

export const getReservationViewInfo = (order) => {
  const data = {
    // icon: DeliveryIcon,
    title: 'confermato',
    statusText: 'Confermato',
    color: '#fad00b',
    // isImg: false,
  };

  switch (order.status) {
    case reservationStatuses.pending:
      data.statusText = 'In attesa della conferma';
      data.color = '#fad00b';
      break;
    case reservationStatuses.declined:
      data.color = '#dd0000';
      data.statusText = 'Rifiutato';
      break;
    case reservationStatuses.confirmed:
      data.color = '#00e268';
      data.statusText = 'Confermato';
      break;
    case reservationStatuses.notVisited:
      data.statusText = 'No show';
      break;
    default:
      break;
  }

  return data;
};

export const getOrderViewInfo = (order) => {
  const data = {
    icon: DeliveryIcon,
    title: 'Delivery',
    statusText: 'Da confermare',
    color: '#fad00b',
    textColor: undefined,
    isImg: false,
  };
  // TODO add new type of order [on_table]
  if (order.order_type === 'delivery') {
  }
  if (order.order_type === OrderTypes.booking) {
    data.icon = ReservationIcon;
    data.title = 'Al tavolo';
  }
  if (order.order_type === OrderTypes.takeaway) {
    // data.icon = AsportoIcon;
    data.icon = <img src={AsportoIcon} alt='asporto' />;
    data.isImg = true;
    data.title = 'Asporto';
  }
  if (order.order_type === OrderTypes.reservation) {
    data.icon = ReservationIcon;
    data.title = 'Al tavolo';
  }

  if (order.order_type === OrderTypes.on_table) {
    data.title = 'Al tavolo';
    data.icon = ReservationIcon;
    data.statusText = 'In attesa';
    data.color = '#fad00b';
  }

  if (order.status === orderStatuses.created) {
    data.statusText = 'Da confermare';
  }
  if (order.status === orderStatuses.preparing) {
    // data.statusText = 'Confermato';
    data.color = '#00e268';
  }
  if (order.status === orderStatuses.delivering) {
    data.statusText = 'In consegna';
    data.color = '#00e268';
  }
  if (order.status === orderStatuses.completed) {
    // data.statusText = 'Completato';
    data.statusText = 'Confermato';
    data.color = '#00e268';
  }
  // if (order.payment && order.payment.amount !== '0,00') {
  //   data.statusText = 'L'ordine e' stato pagato online';
  //   data.color = '#dd0000';
  //   data.textColor = '#dd0000';
  // }
  // TODO ask Mos what is what
  // if (order.status === orderStatuses.created) {
  //   data.statusText = 'In attesa';
  //   data.color = '#00e268';
  // }
  if (order.status === orderStatuses.rejected) {
    data.statusText = 'Rifiutato';
    data.color = '#dd0000';
  }

  return data;
};
